var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartamentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,5c0,2.76-2.24,5-5,5S2,7.76,2,5,4.24,0,7,0s5,2.24,5,5ZM0,18v1c0,.55.45,1,1,1h12c.55,0,1-.45,1-1v-1c0-2.21-1.79-4-4-4h-6c-2.21,0-4,1.79-4,4ZM11.99,9.9c2.7.56,5.35-1.18,5.91-3.88.56-2.7-1.18-5.35-3.88-5.91-.67-.14-1.36-.14-2.03,0,2.67,2.72,2.67,7.08,0,9.79ZM16,14h-1.54c.99,1.1,1.54,2.52,1.54,4v2h3c.55,0,1-.45,1-1v-1c0-2.21-1.79-4-4-4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartamentos);
export default __webpack_public_path__ + "static/media/departamentos.ed50ded3.svg";
export { ForwardRef as ReactComponent };